export const AgendaDays = [
  'icebreaker',
  'day-1',
  'day-2',
  'day-3',
  'day-4',
  'day-5',
];

export const agendaPdfDays = [
  'pre-event-day',
  'event-day-1',
  'event-day-2',
  'event-day-3',
  'event-day-4',
  'event-day-5',
];
